import { publicShareUrl, socialShareLinks } from '../general/social-sharing';
import '../assets/social-share-links.css';

export function SocialShareLinks({ pathname, search }: { pathname: string; search: string }) {
    return <div className="social-share-links" role="group" aria-label="Share">
        {socialShareLinks(publicShareUrl(pathname, search)).map(link => <a key={link.name} href={link.href}
            target="_blank" rel="noopener noreferrer" aria-label={`Share on ${link.name}`} title={`Share on ${link.name}`}>
            <i className={`pi ${link.icon}`} aria-hidden="true" />
        </a>)}
    </div>;
}
